export default __webpack_public_path__ + "static/media/GDSC.42592438.webp";